import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PackageResponse } from "src/domain/client";
import { TranslateModule } from "@ngx-translate/core";
import { RadioButtonComponent } from "../../inputs/radio-button/radio-button.component";
import { PackageContainerV2Component } from "../package-container-v2/package-container-v2.component";
import { PriceDiffComponent } from "../price-diff/price-diff.component";
import { PackageDescriptionComponent } from "../package-description/package-description.component";
import { PackageTitleComponent } from "../package-title/package-title.component";

@Component({
  selector: "app-radio-button-package",
  imports: [
    TranslateModule,
    RadioButtonComponent,
    PackageContainerV2Component,
    PriceDiffComponent,
    PackageTitleComponent,
    PackageDescriptionComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./radio-button-package.component.html"
})
export class RadioButtonPackageComponent {
  package = input<PackageResponse>();
  parentPackage = input<PackageResponse>();
  parentForm = input<FormGroup<any>>();
  togglePackage = input<boolean>();

  packageClicked$ = output<PackageResponse>();

  handlePackageClicked(event: MouseEvent, subPackage: PackageResponse): void {
    event.preventDefault();
    this.packageClicked$.emit(subPackage);
  }

  isSubPackageSelected = computed(() => {
    this.togglePackage();
    const subPackageValue = this.parentForm()
      .get(this.parentPackage().id)
      .get("subcategoryContainer")?.value as string;
    return subPackageValue === this.package().id;
  });
}
